import { actions, mutations } from "@/store";
import { post } from "@/utils/api";
import { trackException } from "@/appInsights";
import { ACTIVITY_ACTIONS } from "@/constants";
import { AppNotification } from "@/constants/appNotification";

export default {
  async getStats({ dispatch, commit }, { from, to }) {
    const limit = 1000;
    const getUrl = offset =>
      `${process.env.VUE_APP_ACTIVITY_LOGS_API}/v1/activitylogs/filter?limit=${limit}&offset=${offset}&orderBy=CreatedUtc&orderDirection=Ascending`;

    const query = {
      entities: ["Identification"],
      publishers: ["BoApi", "ArbitriumApi"],
      actions: [
        ACTIVITY_ACTIONS.OPENED,
        ACTIVITY_ACTIONS.UPDATED,
        ACTIVITY_ACTIONS.CONFIRMED,
        ACTIVITY_ACTIONS.REJECTED
      ],
      createdUtc: { from, to }
    };
    commit(mutations.statsLoadInit, { query });
    try {
      let done = false;
      let allData = [];
      let offset = 0;
      while (!done) {
        const url = getUrl(offset);
        const data = await post(url, query);
        allData = [...allData, ...data];
        offset += data.length;
        done = data.length < limit;
        commit(mutations.statsLoadSuccess, { logs: data, done });
      }
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/stats/getStats" }
      });
      commit(mutations.statsLoadError, { error: error.message });
      dispatch(actions.notificationAdd, {
        id: AppNotification.GetStatsError,
        title: "Getting stats failed",
        message: `Error: "${error.message}"`,
        duration: 0,
        actions: [
          { label: "Dismiss" },
          { label: "Retry", action: actions.getStats }
        ]
      });
    }
  }
};
